export interface FacilityPositionDto {
  id: number;
  facilityId: string; // Guid
  name: string;
  abbreviation: string;
  description?: string | null;
  isActive: boolean;
  createdAt: string; // DateTime as ISO string
}
